import { useTranslation } from 'react-i18next';
import { FilterPopover } from 'src/components/molecules/filter-popover';
import { spaceTypesTranslations } from 'src/features/spaces/constants/space-types-translations';
import { SpaceType } from 'src/features/spaces/types/space-type';
import { SearchState } from 'src/hooks/meilisearch/types/search-state';
import { buildFiltersArrayFromFiltersObject } from 'src/hooks/meilisearch/utils/build-filters-array-from-filters-object';
import { buildFiltersObjectFromFiltersArray } from 'src/hooks/meilisearch/utils/build-filters-object-from-filters-array';
import { FilterGroup } from 'src/types/interfaces/filter-group';

interface Props {
  filters: SearchState['filter'];
  onChange: (filters: SearchState['filter']) => void;
}

export const SpaceTypeFilterPopover = ({ filters, onChange }: Props) => {
  const { t } = useTranslation(['spaceGroups', 'spaces']);

  const filterGroup: FilterGroup<SpaceType> = {
    id: 1,
    type: 'type',
    label: t('spaceGroups:common.createGroupDialog.spaceType'),
    singleOption: false,
    items: [
      {
        label: t(spaceTypesTranslations['DESK']),
        value: 'DESK',
      },
      {
        label: t(spaceTypesTranslations['ROOM']),
        value: 'ROOM',
      },
    ],
  };

  const filtersObject = buildFiltersObjectFromFiltersArray(
    filters as string[][],
  );

  return (
    <FilterPopover
      title={filterGroup.label}
      selected={filtersObject[filterGroup.type] ?? []}
      onChange={option => {
        const filtersArray = buildFiltersArrayFromFiltersObject(
          filterGroup.type,
          option,
          filters,
        );

        onChange(filtersArray);
      }}
      options={filterGroup.items.map(item => ({
        label: item.label,
        value: item.value,
      }))}
      minButtonWidth={100}
    />
  );
};
